import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appNgSelectMultiLabelDirective]',
  standalone: true,
})
export class NgSelectMultiLabelDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
